import apiServiceAsync from '@/api/apiServiceAsync';

const api = await apiServiceAsync();
const url = '/api/v1/reporting/r-reports';

export default {
  getReports() {
    return api.get(url).then((response) => response.data);
  },
  createReport(state, {
    title,
    selectedBuildings,
    inactives,
    favorites,
    comment,
  }) {
    const buildings = selectedBuildings.map((building) => building.value);
    const data = {
      title,
      buildings,
      'no-inactives': !inactives,
      favorits: favorites,
      comment,
      action: 'create_report',
    };

    return api.post(url, data, { timeout: 0 }).then((response) => response.data);
  },
  // Rendered server-side on request (headless Chromium over the warehouse
  // figures), which takes a few seconds - hence no timeout.
  downloadLiveReport() {
    return api.get('/api/v1/reporting/live-report-pdf', {
      responseType: 'arraybuffer',
      timeout: 0,
    });
  },
};
